export const create_a_sales_page_cta_text = "Create a Landing Page";

export const learn_more_description_text =
  "Increase revenue with more sales from captivated leads won over by your landing page";
